import React from 'react';
import PropTypes from 'prop-types';

import introHtml from './static/intro.html';
import promiseHtml from './static/promise.html';
import errorHtml from './static/error.html';
import authHtml from './static/auth.html';

class HtmlPage extends React.Component {

	componentDidMount() {
		if (window.Prism) { window.Prism.highlightAll() }
	}

	componentDidUpdate() {
		if (window.Prism) { window.Prism.highlightAll() }
	}

	render() {

		const { page } = this.props;

		let html = null;
		switch (page) {
			case 'Intro': html = <div dangerouslySetInnerHTML={{ __html: introHtml }} />; break;
			case 'Promise': html = <div dangerouslySetInnerHTML={{ __html: promiseHtml }} />; break;
			case 'Auth': html = <div dangerouslySetInnerHTML={{ __html: authHtml }} />; break;
			case 'Error': html = <div dangerouslySetInnerHTML={{ __html: errorHtml }} />; break;
			default: html = null;
		}

		return (html);
	}
}

HtmlPage.propTypes = {
	page: PropTypes.string.isRequired

};

export default HtmlPage;



// WEBPACK FOOTER //
// ./src/components/javascript-sdk/HtmlPage.js